export const css = {
	root: '_3Dkc8gGu',
	' _key': 'ascm-theme/ascm/table-of-contents/trigger'
};

export default css;
